export const SKELETON_PROPS = {
    text: {
        skeletonHeight: '10px',
        spacing: 4,
        borderRadius: 'lg',
    },
};
